import React from 'react';
import { IconButton, Typography } from 'fronton-react';
import { CopySimpleIcon } from '@fronton/icons-react';
import { SNACKS } from 'common/components/snack/snacks';
import { EridWrapper } from './styles';
import { IconButtonVariant } from 'fronton-react/button/icon-button/types';
import { showNotification } from '@navi-toolbox/ui-components';
import { NotificationTemplates } from '../notification-template-factory/types';

type EridTokenCopingProps = {
  eridToken: string;
  variant?: IconButtonVariant;
};

export const EridTokenCoping = ({ eridToken, variant = 'invert' }: EridTokenCopingProps) => {
  const handleCopyClick = () => {
    window.navigator.clipboard.writeText(eridToken);

    showNotification({
      data: SNACKS.SUCCESS_TOKEN_COPY,
      templateId: NotificationTemplates.WishList,
    });
  };

  return (
    <div className={EridWrapper}>
      <IconButton label="Скопировать erid" variant={variant} onClick={handleCopyClick}>
        <CopySimpleIcon />
      </IconButton>
      <Typography variant="s" size="body_long">
        erid: {eridToken}
      </Typography>
    </div>
  );
};
